import React from "react";
import styles from "./footer.module.css";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaFacebook, FaLinkedin, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
const Footer = () => {
  return (
    <React.Fragment>
      <div className={styles.main_footer}>
        <div className={styles.footer}>
          <div className={styles.right_section}>
            <img src="/images/footer-logo.png" alt="logo" />
            <p>
              To empower businesses through reliable partnerships, seamless
              transactions, and a steadfast dedication to excellence.
            </p>
            <div className={styles.inputSec}>
              <input type="email" inputMode="email" placeholder="Enter Email" />
              <button>Send</button>
            </div>

            <div className={styles.icon_section}>
              <p>follow us on:</p>
              <FaFacebook className={styles.icon} />
              <FaLinkedin className={styles.icon} />
              <FaSquareXTwitter className={styles.icon} />
              <FaYoutube className={styles.icon} />
            </div>
          </div>
          <div className={styles.left_section}>
            <Row>
              <Col md={4} sm={12}>
                <div>
                  <h6>Quick Links</h6>
                  <ul>
                    <li>
                      <Link to={"/about"}>About us</Link>
                    </li>
                    <li>
                      <Link to={"/project"}>Projects</Link>
                    </li>
                    <li>
                      <Link to={"/product"}>Businesses</Link>
                    </li>
                    <li>
                      <Link to={"/career"}>Careers</Link>
                    </li>
                    <li>
                      <Link to={"/news"}>News</Link>
                    </li>
                    <li>
                      <Link to={"/investors"}>Investors</Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={8} sm={12}>
                <div>
                  <h6>Contacts</h6>
                  <ul>
                    <li>
                      <Link to={"#"}>Address</Link>
                      <p>A211, Greenwood City, Sector 45, Gurugram, India</p>
                    </li>
                    <li>
                      <Link to={"#"}>Email</Link>
                      <p>meena@crossborderbtc.com</p>
                    </li>
                    <li>
                      <Link to={"/businesses"}>Phone</Link>
                      <p>
                        +91-124-4059332 <br /> +91-8826710292
                      </p>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className={styles.bottom_footer}>
          <p>All Right Reserved 2025 @CROSSBORDER BTC</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
